import { Box, Typography, Stack, Checkbox, FormControlLabel, Divider, Link as MuiLink } from '@mui/material';
import type { SignupData } from './SignUpWizard';

interface Props {
  data: SignupData;
  onChange: (partial: Partial<SignupData>) => void;
}

export function ReviewStep({ data, onChange }: Props) {
  return (
    <Stack spacing={3}>
      <Typography variant="h6" sx={{ fontWeight: 600, color: '#f0f0f5' }}>
        Review Your Details
      </Typography>

      <Box>
        <Typography sx={{ color: '#3d7aff', fontSize: 12, fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.05em', mb: 1 }}>
          Company
        </Typography>
        <Stack spacing={0.5}>
          <ReviewRow label="Company Name" value={data.companyName} />
          {data.registeredName && <ReviewRow label="Registered Name" value={data.registeredName} />}
          {data.registrationNumber && <ReviewRow label="Registration Number" value={data.registrationNumber} />}
          <ReviewRow label="Entity Type" value={data.entityType} />
          <ReviewRow label="Phone" value={data.contactPhone} />
        </Stack>
      </Box>

      <Divider sx={{ borderColor: 'rgba(255,255,255,0.06)' }} />

      <Box>
        <Typography sx={{ color: '#3d7aff', fontSize: 12, fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.05em', mb: 1 }}>
          Admin Account
        </Typography>
        <Stack spacing={0.5}>
          <ReviewRow label="Name" value={`${data.adminFirstName} ${data.adminLastName}`} />
          <ReviewRow label="Email" value={data.adminEmail} />
          <ReviewRow label="Password" value={'•'.repeat(data.adminPassword.length)} />
        </Stack>
      </Box>

      <Divider sx={{ borderColor: 'rgba(255,255,255,0.06)' }} />

      <FormControlLabel
        control={
          <Checkbox
            checked={data.termsAccepted}
            onChange={(e) => onChange({ termsAccepted: e.target.checked })}
            sx={{ color: '#a0a5b5', '&.Mui-checked': { color: '#3d7aff' } }}
          />
        }
        label={
          <Typography variant="body2" sx={{ color: '#a0a5b5' }}>
            I agree to the{' '}
            <MuiLink href="/terms" target="_blank" rel="noopener" sx={{ color: '#3d7aff', textDecoration: 'none', '&:hover': { textDecoration: 'underline' } }}>
              Terms of Service
            </MuiLink>{' '}
            and{' '}
            <MuiLink href="/privacy" target="_blank" rel="noopener" sx={{ color: '#3d7aff', textDecoration: 'none', '&:hover': { textDecoration: 'underline' } }}>
              Privacy Policy
            </MuiLink>
          </Typography>
        }
      />
    </Stack>
  );
}

function ReviewRow({ label, value }: { label: string; value: string }) {
  return (
    <Stack direction="row" spacing={2}>
      <Typography sx={{ color: '#6b7280', fontSize: 14, minWidth: 140 }}>{label}</Typography>
      <Typography sx={{ color: '#f0f0f5', fontSize: 14, fontWeight: 500 }}>{value}</Typography>
    </Stack>
  );
}
